
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-a-tesla-of-choice",
      function () {
        return require("private-next-pages/landing/win-a-tesla-of-choice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-a-tesla-of-choice"])
      });
    }
  